




export default {
  name: 'basic-img',

  props: {
    src: String
  }
}
